import { useMemo } from "react";

import { useEltSyncsQuery } from "@/apollo/types";

export const useEltSyncs = (options?: { pollInterval?: number }) => {
  const { data, loading } = useEltSyncsQuery({
    ...options,
    skipPollAttempt: () => document.hidden,
  });

  return useMemo(
    () => ({ eltSyncs: data?.eltSyncs ?? [], loading }),
    [data, loading],
  );
};
